export enum ClientLocaleNS {
  Common = 'common',
  HomePage = 'home_page',
  ErrorPage = 'error_page',
  RefundPage = 'refund_page',
  TermsPage = 'terms_page',
  PrivacyPage = 'privacy_page',
  CookiePage = 'cookie_page',
  ProductPage = 'product_page',
  CheckoutPage = 'checkout_page',
  SignUpPage = 'sign_up_page',
  ProfilePage = 'profile_page',
  AboutPage = 'about_page',
}
